module.exports = __webpack_public_path__ + "img/bookmarks.jpg_w545.9401fdca.jpg";